// 阿拉伯语

export default {
  t1: 'تم',
  t5: 'دفع',
  t6: 'اربط وامنح الإذن',
}
